import get from 'lodash/get';
import * as htmlSitemapIndexPageActions from '../../action_creators/html_sitemap/html_sitemap_index_page_action_creators';
import log from '../../../services/logger_service';

import asyncHtmlSitemapIndexActions from './async_html_sitemap_index_actions';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function htmlSitemapIndexDetail(params, store) {
  return function firstDispatchHtmlSitemapIndex(dispatch) {
    dispatch(htmlSitemapIndexPageActions.htmlSitemapIndexPageLoading());
    return Promise.all([
      asyncHtmlSitemapIndexActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function htmlSitemapIndexDetailData() {
        dispatch(
          htmlSitemapIndexPageActions.htmlSitemapIndexPageLoaded({}, store)
        );
        return true;
      })
      .catch(function handlehtmlSitemapIndexError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in html sitemap index page actions, message: ${err.message}`
          );
        }
        return dispatch(
          htmlSitemapIndexPageActions.htmlSitemapIndexPageLoadError(err, store)
        );
      });
  };
}
